import React, { useEffect, useState } from "react";
import Footer from "./Footer";
import GetInTouchFooter from "./GetInTouchFooter";
import WhyPedagogiesVid from "../assets/whyThesePedagogies.mp4";
import heartGif from "../assets/red-heart-bumping.gif";
import HighFive from "./CurriculumOfLove/HighFive";
import CustomVideoModal from "./custom/CustomVideoModal";
import colThumbnail from "../assets/colThumbnail.jpg";
import colHeaderImg from "../assets/colHeader.jpg";
import mobileColHeaderImg from "../assets/mobileColHeader.jpg";
import tabColHeaderImg from "../assets/tabColHeader.jpg";
import { Helmet } from "react-helmet";
import EvolutionImg from "../assets/evolution.png";

const CurricumOfLove = () => {
  useEffect(() => {
    const timer = setTimeout(() => {
      window.scrollTo(0, 1);
    }, 100);
    return () => clearTimeout(timer);
  }, []);

  return (
    <div>
      <Helmet>
        <title>Curriculum of Love at Mother's Pride</title>
        <meta name="description" content="Explore Mother's Pride's Curriculum of Love, a unique blend of global teaching methodologies. Our approach fosters physical, cognitive, emotional, and creative growth." />
        <meta name="keywords" content="Montessori teaching,Reggio Emilia preschool,innovative learning,preschool teaching methods,early education philosophy" />
      </Helmet>
      <div
        style={{
          lineHeight: "1.6",
          textAlign: "center",
        }}
        className="font-Lato overflow-x-hidden"
      >
        {/* Header Section */}
        <div>
          <img
            src={
              window.innerWidth < 450
                ? window.innerWidth < 800
                  ? tabColHeaderImg
                  : mobileColHeaderImg
                : colHeaderImg
            }
            className="w-[100vw] sm:h-[300px] lg:h-[420px]"
            alt="colHeader"
          />
        </div>
        <HighFive />

        {/* 
      <div className="px-5 lg:px-[6%] bg-[#FFF3ED] py-[30px] flex flex-col gap-8 sm:pt-[70px] mb-[50px]">
        <h1
          className="text-[#D31C4F] text-[28px] sm:text-[50px] font-normal sm:leading-[65px] text-center"
          style={{ fontFamily: "Wonderbar" }}
        >
          WHY THESE PEDAGOGIES
        </h1>
       
        <CustomVideoModal
          thumbnail={colThumbnail}
          video={WhyPedagogiesVid}
          width={"100%"}
          height={"500px"}
        />
      </div> */}
        <br />
        <img
          src={EvolutionImg}
          alt=""
          className="py-[50px] sm:py-[70px] bg-[#E0FAFF] lg:py-0"
        />
        {/* Contact Section */}
        <GetInTouchFooter marginX={"6%"} />
        <Footer marginX={"6%"} />
      </div>
    </div>
  );
};

export default CurricumOfLove;
